import { Router } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import history from "./Store/history/history";
import routes from "./Routes/Routes";

// Internal imports
//import LoginRoute from "./Routes/LoginRoute";
import PrivateRoute from './Routes/PrivateRoutes';

function App(props) {
  const {
    toast,
  } = props
  const resolvePrivateRoutes = (routes) => {

    if (routes && Array.isArray(routes)) {
      return routes.map((route) => {

        if (route.isPrivate) {
          route.render = (props) => (
            <PrivateRoute component={route.component} {...props} />
          );
        }
        if (route.isAuth) {
          route.render = (props) => (
            <PrivateRoute component={route.component} {...props} />
          );

        }
        if (route.routes) {
          resolvePrivateRoutes(route.routes);
        }
        return route;
      });
    }
  };

  return (
    <>

      <Router history={history} basename={process.env.PUBLIC_URL}>

        {renderRoutes(resolvePrivateRoutes(routes))}

      </Router>
    </>
  );
}

const mapStateToProps = (state) => {
  return {

  }
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
